var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRfIcon = function SvgRfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14c1.2-1.2 4.333-1.667 5.5-2 1.5 6-2.5 16-5.5 19-2.4 2.4-5 2-6 2-2.5-3-2-7.5-1-10.5s5.5-7 7-8.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.538 0S4.706 5.508.815 17.724c-2.19 6.876.194 13.794 5.22 15.423 2.51.815 4.876-.082 4.876-.082-2.418-2.445-2.871-7.41-.091-12.028 2.8-4.653 6.909-7.191 9.382-8.45C19.662 6.716 17.449 1.68 16.538 0ZM26.457 10.458c-.14.02-2.524.554-5.646 2.13.198 1.985.428 6.51-1.082 11.157-1.562 4.808-4.701 8.109-8.21 9.322 3.562 3.587 9.703 1.349 12.786-3.948 4.865-8.36 2.39-17.78 2.152-18.66Z",
    fill: "#479DA6"
  })));
};
export default SvgRfIcon;